@let invoices = this.invoices();
@if (invoices.length == 1) {
  <app-link-to [url]="'/Insurance/Contracts/Details/'"
               [label]="invoices | showInvoiceAndTruncate : [50]"
               [id]="invoices[0].contractUniqueId" />
} @else if (invoices.length > 1) {
  <a role="button"
     class="link-primary border-0 bg-transparent"
     (click)="openModalBindAccountMovesDetails($event)"
     translate
  >{{
      invoices | showInvoiceAndTruncate : [50]
    }}
  </a>
} @else {
  -
}
